import { render, staticRenderFns } from "./DriverPanel.vue?vue&type=template&id=8045c40a&"
import script from "./DriverPanel.vue?vue&type=script&lang=js&"
export * from "./DriverPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports